import { DNA } from 'react-loader-spinner'
export default function Loader({ show }) {
    if(show){
        return(
            <DNA
                visible={true}
                height="250"
                width="250"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
            />
        )
    }
}